import { Component, input, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoDirective, TranslocoModule } from '@jsverse/transloco';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DialogData, XtDialogComponent } from '@xt/ui-kit';

@Component({
  selector: 'xt-portal-stepper-dialog',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoModule,
    MatProgressBarModule,
    XtDialogComponent,
    TranslocoDirective,
  ],
  templateUrl: './stepper-dialog.component.html',
  styleUrls: ['./stepper-dialog.component.scss'],
})
export class StepperDialogComponent {
  currentStep = input.required<number>();
  stepCount = input.required<number>();
  stepHeader = input.required<string>();
  config = input<DialogData>();
  actionsTemplate = input.required<TemplateRef<unknown>>();
  contentTemplate = input.required<TemplateRef<unknown>>();

  get progressValue(): number {
    return (this.currentStep() / this.stepCount()) * 100;
  }
}
